import { Filter } from 'lucide-react';
import { DevToolsButton } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsButton';
import type { EventsFilteredEmptyProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsFilteredEmpty/index.types';
import React from 'react';

/**
 * EventsFilteredEmpty - The filters matched nothing
 *
 * Deliberately not the full empty state.
 */
export const EventsFilteredEmpty: React.FC<EventsFilteredEmptyProps> = ({
  activeFilters,
  hiddenCount,
  onShowAll,
}) => (
  <div className="flex items-center gap-2.5 p-3">
    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-zinc-800 bg-zinc-900">
      <Filter className="h-3.5 w-3.5 text-zinc-400" strokeWidth={1.7} />
    </span>

    <div className="min-w-0 flex-1">
      <p className="truncate text-[12.5px] font-semibold text-zinc-200">
        No events match{' '}
        <span className="font-sp-mono text-emerald-400">
          {activeFilters.join(' · ')}
        </span>
      </p>
      <p className="text-[11.5px] text-zinc-300">
        {hiddenCount} {hiddenCount === 1 ? 'event' : 'events'} hidden in the
        buffer.
      </p>
    </div>

    <DevToolsButton onClick={onShowAll} className="flex-shrink-0">
      Show all
    </DevToolsButton>
  </div>
);
